import React, { useState } from 'react';
import { FormikProps, getIn } from 'formik';
import { TextField, Icon } from 'bs-unified-ui';
import { useTheme } from '@mui/material/styles';

interface InputProps {
  field: {
    name: string;
    value: any;
  };
  form: FormikProps<any>;
  inputProps?: Record<string, any>;
  error?: string;
  helperText?: string;
  disabled?: boolean;
  type?: string;
  [key: string]: any;
}

const Input: React.FC<InputProps> = ({
  field,
  form,
  inputProps = {},
  error = '',
  helperText = '',
  disabled = false,
  ...props
}) => {
  const theme = useTheme();
  const [show, setShow] = useState(false);

  return (
    <TextField
      error={
        !!error ||
        (!!getIn(form.touched, field.name) && !!getIn(form.errors, field.name))
      }
      helperText={
        helperText ||
        (getIn(form.touched, field.name) && getIn(form.errors, field.name))
      }
      inputProps={{
        ...field,
        ...inputProps,
        value: field.value ?? '',
      }}
      sx={{
        '& input:-internal-autofill-selected, input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active':
          {
            WebkitTextFillColor: `${theme.foreground.black} !important`,
          },
      }}
      disabled={disabled || !!form.values?.__readOnly}
      hasValue={field.value}
      endAdornment={
        props?.type === 'password' && (
          <div
            role='presentation'
            onClick={() =>
              !(disabled || !!form.values?.__readOnly) && setShow(!show)
            }
            style={{
              cursor: !(disabled || !!form.values?.__readOnly)
                ? 'pointer'
                : 'unset',
            }}
          >
            {show ? (
              <Icon
                name='eye'
                type='fill'
                color={theme.background.outlineDivider}
              />
            ) : (
              <Icon
                name='eye-off'
                type='fill'
                color={theme.background.outlineDivider}
              />
            )}
          </div>
        )
      }
      {...props}
      type={
        // eslint-disable-next-line no-nested-ternary
        props?.type === 'password' ? (show ? 'text' : 'password') : props?.type
      }
    />
  );
};

export default Input;
